import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import {fontWeight} from '@styles/helpers';
import {placeholder} from '@styles/reusable';

export const InputWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  input,
  select,
  [data-input='true'] {
    all: unset;
    width: 100%;
    border: 1px solid ${(props) => props.theme.colors.buttonBorderColor};
    border-radius: ${(props) => props.theme.pillBorderRadius}px;
    padding-left: 10px;
    height: 30px;
    box-sizing: border-box;
    color: ${(props) => props.theme.colors.mainTextColor};

    ${placeholder(`color: ${(props) => props.theme.colors.placeholderColor}`)}

    &[type="date"] {
      appearance: none;
      font-size: ${(props) => props.theme.fontSizes.tiny}px;
      padding-right: 15px;
    }
  }
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: ${(props) => props.theme.colors.buttonColor};
  display: flex;
  border-radius: ${(props) => props.theme.pillBorderRadius}px;
  font-size: ${(props) => props.theme.fontSizes.tiny}px;
  justify-content: space-between;
  font-weight: ${fontWeight.bold};
`;

export const Title = styled.span`
  font-size: 15px;
  color: ${colors.mainTextColor};
  margin-right: 10px;
`;
